export default angular.module("ConfirmDirective", []).directive("confirm", ["$modal", "$parse", ($modal, $parse) => ({
  // So the link function is run before ngClick's, which has priority 0
  priority: -1,
  link: (scope, element, attrs) => {
    element.bind("click", (event) => {
      // Don't run ngClick's handler
      event.stopImmediatePropagation();
      // Prevent anchor "button" url change
      event.preventDefault();

      $modal
        .open({
          templateUrl: "view/modal/confirmation.html",
          controller: "ConfirmationController",
          resolve: {
            title: () => "Are you sure?",
            bodyContent: () => attrs.confirm,
          },
        })
        .result.then(() => {
        // Pass original click as '$event'
          $parse(attrs.ngClick)(scope, { $event: event });
        });
    });
  },
})]);
